import React, { useRef, useState } from 'react';
// @ts-ignore
import Form from 'react-validation/build/form';
// @ts-ignore
import Button from 'react-validation/build/button';
import { TPageNotification } from '../../../../types';
import { ValidationInput } from '../../../common/ValidationInput';
import { executeHttpRequest } from '../../../../epics/api';
import { validateForm } from '../../../base/login/validateForm';

type TChangePasswordProps = {
    notification: TPageNotification;
}

export default function ChangePassword({
    notification,
    }: TChangePasswordProps) {
    const [oldPassword, setOldPassword] = useState('');
    const [password1, setPassword1] = useState('');
    const [password2, setPassword2] = useState('');

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const formRef = useRef();
    const oldPasswordRef = useRef();
    const password1Ref = useRef();
    const password2Ref = useRef();
    const errorMessageDivRef = useRef();

    const validateRequired = (value: string) =>
        !value.toString().trim().length ? 'Required' : null;

    const clearFields = () => {
        setOldPassword('');
        setPassword1('');
        setPassword2('');
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);

        const payload = {
            old_password: oldPassword,
            password1,
            password2,
        };

        executeHttpRequest('user/change-password/', 'post', payload)
            .then(() => {
                setIsLoading(false);
                setError(null);
                clearFields();
                notification.success('Success', 'Password changed!');
            }).catch(err => {
                const fieldRefs = {
                    old_password: oldPasswordRef.current,
                    password1: password1Ref.current,
                    password2: password2Ref.current
                };
                const errorMessage = validateForm(
                    formRef.current, fieldRefs, err.response, false, errorMessageDivRef.current,
                );
                setIsLoading(false);
                setError(errorMessage);
            });
    };

    return (
        <div className="change-password-main">
            <div className="change-password-content-header">
                <h1 className="change-password-content-header__title">Change Password</h1>
            </div>
            <div className="change-password-content">
                <Form
                    ref={formRef}
                    className="change-password-form"
                    onSubmit={handleSubmit}
                >
                    {error &&
                        <div ref={errorMessageDivRef} className="change-password-error">{error}</div>
                    }
                    <ValidationInput
                        ref={oldPasswordRef}
                        type="password"
                        name="old_password"
                        value={oldPassword}
                        placeholder="Old Password"
                        className="input--round"
                        containerClassName="input-wrapper"
                        errorClassName="input--invalid"
                        onChange={(e: any) => setOldPassword(e.target.value)}
                        validations={[validateRequired]}
                    />
                    <ValidationInput
                        ref={password1Ref}
                        type="password"
                        name="password1"
                        value={password1}
                        placeholder="New Password"
                        className="input--round"
                        containerClassName="input-wrapper"
                        errorClassName="input--invalid"
                        onChange={(e: any) => setPassword1(e.target.value)}
                        validations={[validateRequired]}
                    />
                    <ValidationInput
                        ref={password2Ref}
                        type="password"
                        name="password2"
                        value={password2}
                        placeholder="Confirm Password"
                        className="input--round"
                        containerClassName="input-wrapper"
                        errorClassName="input--invalid"
                        onChange={(e: any) => setPassword2(e.target.value)}
                        validations={[validateRequired]}
                    />
                    {isLoading ? (
                        <button className="btn--round-big" type="button" disabled={true}>SAVING...</button>
                    ) : (
                        <Button className="btn--round-big" type="submit">SAVE</Button>
                    )}
                </Form>
            </div>
        </div>
    );
}
